var map = {
	"./template.betgalaxy": 2058,
	"./template.betgalaxy.tsx": 2058,
	"./template.betprofessor": 1134,
	"./template.betprofessor.tsx": 1134,
	"./template.betroyale": 1135,
	"./template.betroyale.tsx": 1135,
	"./template.default": 658,
	"./template.default.tsx": 658,
	"./template.fiestabet": 1136,
	"./template.fiestabet.tsx": 1136,
	"./template.puntcity": 1137,
	"./template.puntcity.tsx": 1137,
	"./template.puntgenie": 1138,
	"./template.puntgenie.tsx": 1138,
	"./template.questbet": 1139,
	"./template.questbet.tsx": 1139,
	"./template.ts": 968,
	"./template.volcanobet": 1140,
	"./template.volcanobet.tsx": 1140,
	"./template.wellbet": 1141,
	"./template.wellbet.tsx": 1141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2429;